import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { QueryClient, QueryClientProvider } from 'react-query';
const root = ReactDOM.createRoot(document.getElementById('root'));
// Mirror the tuned defaults used by bxi-dashboard so the admin panel does not
// refetch every active query on each window refocus / route remount. Without
// these, react-query v3 defaults (staleTime: 0, refetchOnWindowFocus: true)
// caused all ~70 admin queries to refire whenever an admin tabbed back.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data considered fresh
      cacheTime: 10 * 60 * 1000, // 10 minutes in cache
      refetchOnWindowFocus: false, // don't refetch just because the window regained focus
      refetchOnMount: true, // refetch on mount only when stale
      retry: 2,
      refetchOnReconnect: true,
    },
  },
});
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>
);
